module.exports = __webpack_public_path__ + "static/media/steel-magnolias.3abec1ac.webp";